//

import UIkit from "uikit";
import {loadStripe} from "@stripe/stripe-js";

const DEV_MODE = (window.location.hostname === 'localhost');
const STRIPE_PUBLISHABLE_KEY = DEV_MODE ? 'pk_test_hBg7VUKMGsCU9oSuqhXteEAs' : 'pk_live_Vipcv6OkbBX6jyjuNorz3qTy';
const FSPACE_API_URL = DEV_MODE ? 'http://localhost:57975' : 'https://api.fspace.me';

function setCookie(name, value, days) {
    let expires = "";
  
    if (days !== undefined) {
      const date = new Date();
  
      if (days === 0) {
        // Session cookie: no expiration date set
        expires = "";
      } else if (days === null) {
        // End of current day: set expiration to midnight
        date.setHours(23, 59, 59, 999);
        expires = "; expires=" + date.toUTCString();
      } else {
        // Days-based expiration: expire after specified number of days
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
    }
  
    document.cookie = `${name}=${encodeURIComponent(value) || ""}${expires}; path=/`;
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }
    return null;
  }
  function deleteCookie(name) {
    setCookie(name, "", -1); // Expiration time in the past
  }


function showError(error) {
    UIkit.modal(document.getElementById('error-modal')).show();
    console.error("There has been a problem with your fetch operation:", error);
    return false;
}
function _paint(replacements) {
    const keys = Object.keys(replacements);
    for (let i=0; i< keys.length; i++) {
        const key = keys[i];
        const elements = document.querySelectorAll('*[' + key + ']');
        for (let j=0; j<elements.length; j++) {
            if ( elements[j].getAttribute(key) ) {
                elements[j][elements[j].getAttribute(key)] = replacements[key]();
            }
            else {
                elements[j].innerHTML = replacements[key]();
            }
        }
    }
}
function paint(plan, initial=false) {
    const replacements_initial = {
        'f-plan-name': function () {
            return plan.name;
        },
        'f-plan-price': function () {
            plan._price = Math.round(plan.price_per_cycle_in_cents * 1.1) / 100;
            return plan._price;
        },
        'f-plan-synopsis': function () {
            return plan.description.split('\r\n').at(0);
        },
        'f-plan-features': function () {
            return plan.description.split('\r\n')
                .filter(function (text, i) {
                    return i && text;
                })
                .map(function (text, i) {
                    return '<li><span uk-icon="check"></span> ' + text.replace('· ', '') + '</li>';
                })
                .join('');
        },
        'f-plan-extras': function () {
            let html = '';
            plan._fields = {};

            for (let x = 0; x < plan.extras.length; x++) {
                const extra = {
                    internal_id: plan.extras[x].id,
                    name: plan.extras[x].name,
                    price: Math.round(plan.extras[x].price_in_cents * 1.1) / 100,
                };

                switch (plan.extras[x].name) {
                    case '24x7 Access':
                        plan._fields.extras_access = extra;
                        html +=
                            '<h4>Access</h4>\n' +
                            // '<a href="#modal">What option is right for you?</a>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_access_default" name="extras_access" value="" checked>\n' +
                            '  <label for="extra_access_default">\n' +
                            '    <strong>Weekdays, 8 am to 6 pm, excluding public holidays</strong>\n' +
                            '    <span></span>\n' +
                            '  </label>\n' +
                            '</div>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_access_24x7" name="extras_access" value="' + extra.internal_id + '">\n' +
                            '  <label for="extra_access_24x7">\n' +
                            '    <strong>24x7, all year round</strong>\n' +
                            '    <span>+ $' + extra.price + ' / month</span>\n' +
                            '  </label>\n' +
                            '</div>\n';
                        break;
                    case 'Locker':
                        plan._fields.extras_locker = extra;
                        html +=
                            '<h4>Locker</h4>\n' +
                            // '<a href="#modal">What option is right for you?</a>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_locker_default" name="extras_locker" value="" checked>\n' +
                            '  <label for="extra_locker_default">\n' +
                            '    <strong>No locker</strong>\n' +
                            '    <span></span>\n' +
                            '  </label>\n' +
                            '</div>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_locker_addon" name="extras_locker" value="' + extra.internal_id + '">\n' +
                            '  <label for="extra_locker_addon">\n' +
                            '    <strong>Locker with key</strong>\n' +
                            '    <span>+ $' + extra.price + ' / month</span>\n' +
                            '  </label>\n' +
                            '</div>\n';
                        break;
                    case 'Monitor Storage (for BYO)':
                        plan._fields.extras_monitorstorage = extra;
                        html +=
                            '<h4>Monitors</h4>\n' +
                            // '<a href="#modal">What option is right for you?</a>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_monitorstorage_default" name="extras_monitorstorage" value="" checked>\n' +
                            '  <label for="extra_monitorstorage_default">\n' +
                            '    <strong>Book ours, from $1/day</strong>\n' +
                            '    <span></span>\n' +
                            '  </label>\n' +
                            '</div>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_monitorstorage_addon" name="extras_monitorstorage" value="' + extra.internal_id + '">\n' +
                            '  <label for="extra_monitorstorage_addon">\n' +
                            '    <strong>Storage for BYO</strong>\n' +
                            '    <span>+ $' + extra.price + ' / month</span>\n' +
                            '  </label>\n' +
                            '</div>\n';
                        break;
                    case 'Shared Monitor':
                        plan._fields.extras_sharedmonitor = extra;
                        html +=
                            '<h4>Monitors</h4>\n' +
                            // '<a href="#modal">What option is right for you?</a>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_sharedmonitor_default" name="extras_sharedmonitor" value="" checked>\n' +
                            '  <label for="extra_sharedmonitor_default">\n' +
                            '    <strong>No monitors</strong>\n' +
                            '    <span></span>\n' +
                            '  </label>\n' +
                            '</div>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_sharedmonitor_addon" name="extras_sharedmonitor" value="' + extra.internal_id + '">\n' +
                            '  <label for="extra_sharedmonitor_addon">\n' +
                            '    <strong>Access to shared monitors. Put away after use.</strong>\n' +
                            '    <span>+ $' + extra.price + ' / month</span>\n' +
                            '  </label>\n' +
                            '</div>\n';
                        break;
                    case 'Sit/Stand Desk':
                        plan._fields.extras_desk = extra;
                        html +=
                            '<h4>Desk</h4>\n' +
                            // '<a href="#modal">What option is right for you?</a>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_desk_default" name="extras_desk" value="" checked>\n' +
                            '  <label for="extra_desk_default">\n' +
                            '    <strong>Regular</strong>\n' +
                            '    <span></span>\n' +
                            '  </label>\n' +
                            '</div>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extra_desk_addon" name="extras_desk" value="' + extra.internal_id + '">\n' +
                            '  <label for="extra_desk_addon">\n' +
                            '    <strong>Electric Sit / Stand</strong>\n' +
                            '    <span>+ $' + extra.price + ' / month</span>\n' +
                            '  </label>\n' +
                            '</div>\n';
                        break;
                    case '2x Monitors':
                        plan._fields.extras_2monitors = extra;
                        html +=
                            '<h4>Monitors</h4>\n' +
                            // '<a href="#modal">What option is right for you?</a>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extras_2monitors_default" name="extras_2monitors" value="" checked>\n' +
                            '  <label for="extras_2monitors_default">\n' +
                            '    <strong>BYO or share included</strong>\n' +
                            '    <span></span>\n' +
                            '  </label>\n' +
                            '</div>\n' +
                            '<div class="input-radio">\n' +
                            '  <input type="radio" id="extras_2monitors_addon" name="extras_2monitors" value="' + extra.internal_id + '">\n' +
                            '  <label for="extras_2monitors_addon">\n' +
                            '    <strong>Two adjustable 27&quot; Dell monitors (USB-C &amp; HDMI)</strong>\n' +
                            '    <span>+ $' + extra.price + ' / month</span>\n' +
                            '  </label>\n' +
                            '</div>\n';
                        break;
                }

            }

            return html;
        }
    };
    const replacements = {
        'f-live-price': function() {
            let total_in_cents = (plan._price * 100);

            const inputs = document.getElementById('join-form').elements;
            for (let i = 0; i < inputs.length; i++) {
                if (inputs[i].nodeName === "INPUT" && inputs[i].name.substring(0, 7) === "extras_" && inputs[i].checked == true && inputs[i].value != '') {
                    const field_settings = plan._fields[ inputs[i].name ];
                    total_in_cents += field_settings.price * 100;
                }
            }

            return total_in_cents / 100;
        },
        'f-review-table': function() {
            let total_in_cents = 0

            let html =
                '<tbody>\n' +
                '  <tr>\n' +
                '    <td>' + plan.name + ' Membership</td>\n' +
                '    <td>$' + plan._price + ' AUD</td>\n' +
                '  </tr>\n';

            total_in_cents += (plan._price * 100);

            const inputs = document.getElementById('join-form').elements;
            for (let i = 0; i < inputs.length; i++) {
                if (inputs[i].nodeName === "INPUT" && inputs[i].name.substring(0, 7) === "extras_" && inputs[i].checked == true && inputs[i].value != '') {
                    const field_settings = plan._fields[ inputs[i].name ];
                    total_in_cents += field_settings.price * 100;

                    html +=
                        '  <tr>\n' +
                        '    <td>+ ' + field_settings.name + '</td>\n' +
                        '    <td>$' + field_settings.price + ' AUD</td>\n' +
                        '  </tr>\n';
                }
            }

            const gst = Math.round (total_in_cents * 0.090909 ) / 100;
            const total = total_in_cents / 100;

            html +=
                '</tbody>\n' +
                '<tfoot>\n' +
                '  <tr class="gst">\n' +
                '    <td>10% GST (included)</td>\n' +
                '    <td>$' + gst + ' AUD</td>\n' +
                '  </tr>\n' +
                '  <tr class="total">\n' +
                '    <td>Monthly Total</td>\n' +
                '    <td>$' + total + ' AUD</td>\n' +
                '  </tr>\n' +
                '</tfoot>';
            return html;
        },
        'f-discount-section': function () {

            const discount = {
                code: document.getElementById('discount_code_hidden').value,
                percent: document.getElementById('discount_percent_hidden').value,
                terms: document.getElementById('discount_terms_hidden').value,
                description: document.getElementById('discount_description_hidden').value
            };

            if (discount.code === '') {
                return '';
            }

            const terms = discount.terms > 1 ? discount.terms + ' months' : ' month';
            const total = Math.round( plan._price * 100 ) / 100;
            const total_with_discount = Math.round( (plan._price * (1 - discount.percent)) * 100 ) / 100;
            const html_terms = discount.terms > 0 
                ? 'for the first ' + terms + ', then $' + total + ' AUD per month'
                : 'per month, excluding add-ons. Eligibility must be maintained.';
            const html =
                '<div class="show-discount">' +
                '<h5>Offer Applied!</h5>' +
                discount.description + '<br>' +
                'You\'ll be charged $' + total_with_discount + ' AUD ' + html_terms +
                '</div>';
            return html;

        }
    }

    if (initial === true) {
        _paint(replacements_initial);
    }

    _paint(replacements);

}

function ordinalSuffix(number) {
    const last_two_digits = Number(number.substring(-2));

    if (last_two_digits > 3 && last_two_digits < 21)
        return "th";

    switch (last_two_digits % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
    }
}

// Returns the ISO week of the date.
Date.prototype.getWeek = function() {
    var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
        - 3 + (week1.getDay() + 6) % 7) / 7);
}

Date.prototype.getMonday = function () {
    let day = this.getDay(),
        diff = this.getDate() - day + (day == 0 ? -6 : 1);
    return new Date(this.setDate(diff));
}
Date.prototype.getSunday = function () {
    let day = this.getDay(),
        diff = this.getDate() + (day == 0 ? 0 : 7 - day);
    return new Date(this.setDate(diff));
}

Date.prototype.addWeek = function () {
    let new_date = new Date(this);
    new_date.setDate(this.getDate() +7)
    return new_date;
}

Date.prototype.addMonth = function () {
    let new_date = new Date(this);
    new_date.setMonth(this.getMonth() +1)
    return new_date;
}

function populateWeeks(date, weeks, i=0) {

    weeks.push({
        week_number: date.getWeek(),
        start: date.getMonday(),
        end: date.getSunday()
    });

    if (i < 4) {
        weeks = populateWeeks(
            date.addWeek(),
            weeks,
            i+1
        );
    }

    return weeks;
}

function setBooking(stamp) {

    const date = new Date(stamp);

    document.getElementById('appointment-date').innerHTML = [
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            weekday: 'long'
        }),
        ', ',
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            month: 'long'
        }),
        ' ',
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        }),
        ordinalSuffix(date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        }))
    ].join('');

    document.getElementById('appointment-time').innerHTML = [
        date.toLocaleTimeString('en-AU', {
            timeZone: 'Australia/Perth',
            hour12: true,
            hour: 'numeric'
        })
    ].join('');

    let html = '';
    html += 'Welcome Tour: ' + [
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            month: 'long'
        }),
        ' ',
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        }),
        ordinalSuffix(date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        })),
        ', ',
        date.toLocaleTimeString('en-AU', {
            timeZone: 'Australia/Perth',
            hour12: true,
            hour: 'numeric'
        })
    ].join('') + '<br>';

    html += 'Membership Starts: ' + [
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            month: 'long'
        }),
        ' ',
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        }),
        ordinalSuffix(date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        })),
        ' ',
        date.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            year: 'numeric'
        }),
    ].join('') + '<br>';

    const renewDate = date.addMonth();

    html += 'Membership Renews: ' + [
        renewDate.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            month: 'long'
        }),
        ' ',
        renewDate.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        }),
        ordinalSuffix(renewDate.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            day: 'numeric'
        })),
        ' ',
        renewDate.toLocaleDateString('en-AU', {
            timeZone: 'Australia/Perth',
            year: 'numeric'
        }),
    ].join('') + '<br>';

    document.querySelector('*[f-review-dates]').innerHTML = html;
    document.querySelector('*[f-booking-stamp]').value = stamp;
}

function paintAvailability(slots) {
    let tree = {};
    let default_stamp;

    const weeks = populateWeeks(new Date(), []);

    for (let i=0; i<slots.length; i++) {
        const stamp = slots[i];
        const stamp_date = stamp.substring(0, 10);
        const date = new Date(slots[i]);

        if ( typeof tree[stamp_date] == 'undefined') {
            tree[stamp_date] = {
                date: date,
                parts: {
                    weekday: date.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        weekday: 'long'
                    }),
                    day: date.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        day: 'numeric',
                    }),
                    suffix: ordinalSuffix(date.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        day: 'numeric',
                    })),
                    month: date.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        month: 'long',
                    }),
                    year: date.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        year: 'numeric',
                    }),
                },
                times: []
            };
        }

        tree[stamp_date].times.push({
            stamp: stamp,
            label: date.toLocaleTimeString('en-AU', {
                timeZone: 'Australia/Perth',
                hour12: true,
                hour: 'numeric'
            })
        });

        if ( i === 0 ) {
            default_stamp = stamp;
        }

    }

    const keys = Object.keys(tree);

    let html = '';
    for (let j=0; j<weeks.length; j++) {
        const week = weeks[j];

        const week_label = (function() {
            switch (j) {
                case 0: return 'This Week';
                case 1: return 'Next Week';
                default: return [
                    week.start.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        month: 'long'
                    }),
                    ' ',
                    week.start.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        day: 'numeric'
                    }),
                    ordinalSuffix(week.start.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        day: 'numeric'
                    })),
                    ' - ',
                    week.end.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        month: 'long'
                    }),
                    ' ',
                    week.end.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        day: 'numeric'
                    }),
                    ordinalSuffix(week.end.toLocaleDateString('en-AU', {
                        timeZone: 'Australia/Perth',
                        day: 'numeric'
                    }))
                ].join('');
            }
        })();

        html += '<div class="appointment-week">\n' +
            '<div class="legend">' + week_label + '</div>\n';

        for (let k=0; k<keys.length; k++) {
            const subtree = tree[keys[k]];
            if ( subtree.date.getWeek() === week.week_number ) {
                html +=
                    '  <div class="appointment-day">\n' +
                    '    <div class="legend">' +
                    '        <span class="dayname">' + subtree.parts.weekday + '</span>' +
                    '        ' + subtree.parts.month.toUpperCase() +
                    '        ' + subtree.parts.day.toUpperCase() + subtree.parts.suffix + ',' +
                    '        ' + subtree.parts.year +
                    '    </div>\n';

                for (let l=0; l<subtree.times.length; l++) {
                    const selected = ( k+l === 0 ) ? 'selected' : '';

                    const time = subtree.times[l];
                    html +=
                        '    <div class="appointment-slot ' + selected + '" timestamp="' + time.stamp + '">' + time.label + '</div>\n';
                }

                html +=
                    '  </div>\n';
            }
        }

        html +=
            '</div>';

    }

    setBooking(default_stamp);
    document.querySelector('*[f-availability]').innerHTML = html;

    let selected_stamp = default_stamp;

    document.getElementById('booking-save').addEventListener('click', function() {
        setBooking(selected_stamp);
        UIkit.modal('#join-appointment-selector').hide();
    });

    const appointmentSelectors = document.getElementsByClassName('appointment-selector');

    for (let i=0; i< appointmentSelectors.length; i++) {
        const appointmentSelector = appointmentSelectors[i];
        const body = appointmentSelector.querySelector('.appointment-selector-body');

        const scrollers = appointmentSelector.getElementsByClassName('appointment-scroll-down');

        for (let j=0; j< scrollers.length; j++) {
            const scroller = scrollers[j];
            scroller.addEventListener('click', function(evt) {
                evt.stopPropagation();
                evt.preventDefault();

                body.scrollTop += 25;
            });
        }

        const slots = appointmentSelector.getElementsByClassName('appointment-slot');

        for (let k=0; k< slots.length; k++) {
            const slot = slots[k];
            slot.addEventListener('click', function(evt) {
                for (let l=0; l< slots.length; l++) {
                    slots[l].classList.remove('selected');
                }

                slot.classList.add('selected');
                selected_stamp = slot.attributes['timestamp'].value;
            })
        }


    }

}

NodeList.prototype.setDisabled = function(disable = true) {
    for (let i=0; i<this.length; i++) {
        switch(this.item(i).nodeName) {
            case 'INPUT':
            case 'BUTTON':
                this.item(i).disabled = disable ? 'disabled' : '';
                break;
            default:
                if (disable)
                    this.item(i).setAttribute('disabled', 'disabled');
                else
                    this.item(i).removeAttribute('disabled');
                break;
        }

    }
    return this;
}

function showStripeMessage(messageText) {
    const messageContainer = document.querySelector("#payment-message");

    messageContainer.classList.remove("uk-hidden");
    messageContainer.textContent = messageText;

    setTimeout(function () {
        messageContainer.classList.add("uk-hidden");
        messageContainer.textContent = "";
    }, 4000);
}

function applyDiscountCode(discount_code) {
    const REA_discount = {
        percent: 0.35,
        terms: 3,
        description: '35% off for the first 3 months'
    };
    const lookup_table = {
        'DAY1.35%': {
            percent: 0.35,
            terms: 1,
            description: '35% off for the first month'
        },
        'WEEK1.20%': {
            percent: 0.20,
            terms: 1,
            description: '20% off for the first month'
        },
        'WAGIC': {
            percent: 0.20,
            terms: 0,
            description: '20% off for current WAGIC members'
        },
        'RW35': REA_discount,
        'CY35': REA_discount,
        'FC35': REA_discount,
        'WH35': REA_discount,
        'WELCOME35': REA_discount, // Fspace
    };

    if (typeof lookup_table[discount_code] === 'undefined') {
        throw new Error("Invalid promotion code");
    }

    const config = lookup_table[discount_code];

    document.getElementById('discount_code_hidden').value = discount_code;
    document.getElementById('discount_percent_hidden').value = config.percent;
    document.getElementById('discount_terms_hidden').value = config.terms;
    document.getElementById('discount_description_hidden').value = config.description;

    setCookie('discount_code', discount_code);

    document.getElementById('join-form').dispatchEvent(new Event('change'));

    // alert(config.description);
}

async function main() {
    try {

        let elements;
        let stripe;

        // const stripe = new Stripe('sk_test_QvR9zYHwIdYt0VK33ojEhPxS');
        loadStripe(STRIPE_PUBLISHABLE_KEY)
            .then(async function(_stripe) {
                stripe = _stripe;

                const response = await fetch(FSPACE_API_URL + "/stripe/setup", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({  }),
                });
                const { clientSecret } = await response.json();

                elements = stripe.elements({
                    clientSecret,
                    appearance: { theme: 'stripe' }
                });

                const paymentElement = elements.create("payment", {
                    layout: "tabs",
                });
                let val = paymentElement.mount("#payment-element");

            })
            .catch(function(evt) {
                console.log(evt);
            });

        const form = document.querySelector("#join-form");
        form.addEventListener("submit", async function(evt) {
            evt.preventDefault();
            evt.stopPropagation();

            const formData = new FormData(form);
            const values = Object.fromEntries(formData);

            const url = new URL(FSPACE_API_URL + '/checkout');
            url.searchParams.set('plan_id', plan.id);
            url.searchParams.set('name', values.name);
            url.searchParams.set('company', values.company);
            url.searchParams.set('phone', values.phone);
            url.searchParams.set('email', values.email);
            url.searchParams.set('booking', values.booking);
            url.searchParams.set('agree_terms', values.agree_terms);
            url.searchParams.set('agree_ontime', values.agree_ontime);
            url.searchParams.set('agree_price', values.agree_price);
            url.searchParams.set('discount_code', values.discount_code);
            url.searchParams.set('discount_terms', values.discount_terms);
            url.searchParams.set('discount_percent', values.discount_percent);

            const extraIDs = [];
            const extraKeys = Object.keys(values);
            for (let i=0; i<extraKeys.length; i++) {
                const key = extraKeys[i];
                if ( key.substring(0,7) === 'extras_' ) {
                    extraIDs.push( values[key] );
                }
            }

            url.searchParams.set('extras', extraIDs.join(','));

            const inputs = form.querySelectorAll('input,button,a,#payment-element');
            inputs.setDisabled(true);

            const {error} = await stripe.confirmSetup({
                elements,
                confirmParams: {
                    // Return URL where the customer should be redirected after the SetupIntent is confirmed.
                    return_url: url.toString(),
                },
            });

            if (error) {
                // Inform the customer that there was an error.
                // showStripeMessage(error.message);
                let error_message = "There's been an error processing your payment.\n\nError type: " + error.type + "\n";
                if (error.message.length > 0) {
                    error_message += "Error message: " + error.message;
                }
                alert(error_message);
                inputs.setDisabled(false);
            }

        });


        const urlParams = new URLSearchParams(window.location.search);
        const plan_name = urlParams.get('plan');

        fetch(FSPACE_API_URL + '/bookings/availability', {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        })
            .then(function(response) {

               if (!response.ok) {
                   return showError("Booking system error #1");
               }

               response.json()
                   .then(function(json) {
                       paintAvailability(json);
                   })
                   .catch(function(e) {
                       return showError("Booking system error #2");
                   });
            })
            .catch(function(e) {
                return showError("Booking system error #3");
            });

        const response = await fetch(FSPACE_API_URL + "/plans", {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        });
        if (!response.ok) {
            return showerror("Network response was not OK");
        }

        const plans = await response.json();

        const plan = plans.filter(function(plan, i){ return plan.name.toLowerCase() === plan_name; }).at(0);

        paint(plan, true);

        document.getElementById('join-form').addEventListener('change', function(evt) {
           paint(plan);
        });

        document.getElementById('promotion-apply').addEventListener('click', function(evt) {
            try {
                applyDiscountCode(document.getElementById('form-promotion-code').value.toUpperCase());
            }
            catch (error) {
                alert(error);
                return;
            }
            
            UIkit.modal('#promotion-form-modal').hide();
        });

        try {
            applyDiscountCode(getCookie('discount_code'));
        }
        catch (error) {
            // fail silently
        }


        document.getElementById('join-loading').style.display = 'none';
        const cards = document.getElementsByClassName('uk-card');
        for (let k=0; k<cards.length; k++) {
            cards[k].style.transition = 'opacity 0.25s ease-in';
            cards[k].style.opacity = '1';
        }

    }
    catch (error) {
        showError(error);
    }

}

window.addEventListener('unload', function(e){
    window.scrollTo(0, 0);
});

main();